import * as React from 'react';
export const Context = React.createContext({ state: {} });